import { Flex, useBreakpointValue } from "@chakra-ui/react";
import LaunchdeckButton from './LaunchdeckButton';


export default function LaunchdeckModalButtonBar({
  handleCloseModal, 
  fontSize = '0.875em',
  bg = 'brand.500',
  color = 'white',
  loadingLogic,
  ctaFunction,
  ctaLabel = 'Next',
  cancelLabel = 'Cancel',
  noCancelOption
}) {

  const buttonWidth = useBreakpointValue({ base: "100%", md: "unset" });

  return (
    <Flex w='100%' direction={['column-reverse', 'row']} mt='1em' gap='0.8em' maxW='inherit' justify={(noCancelOption || loadingLogic) ? 'flex-end' :'space-between'} align='center' px='2em' py='1em' fontSize={fontSize} >
      {!noCancelOption && <LaunchdeckButton w={buttonWidth} visibility={(loadingLogic || noCancelOption) ? 'hidden': undefined} bg='gray.100' borderColor='gray.200' color='brand.700' onClick={!noCancelOption && handleCloseModal} label={cancelLabel} />}
      <LaunchdeckButton w={buttonWidth} loadingLogic={loadingLogic} bg={bg} color={color} onClick={ctaFunction} label={ctaLabel} />
    </Flex>
  )  
}
